<template>
  <v-alert
    border="right"
    :type="tipo"
    text
    outlined
    class="main-alert"
    dense
    :icon="icon"
  >
      <slot>Não encontramos resultados para este recurso.</slot>
  </v-alert>
</template>

<script>
export default {
  name: 'SGPAlertaComponent',

  props: {
    tipo: {
      type: String,
      required: false,
      default: 'orange'
    },
    conteudo: {
      type: String,
      required: false,
      default: 'Não encontramos resultados para este recurso.'
    },

    icon: {
      type: String,
      required: false,
      default: 'mdi-alert-circle-outline'
    }
  }
}
</script>

<style lang="scss">

.main-alert .v-alert__wrapper > i {
  margin-top: 3px !important;
}
</style>